import { z } from "zod";

export const TutorialId = z.enum([
  "WELCOME",
  "HOW_CREDITS_WORK",
  "CAMERA_MOVEMENTS",
  "CLIP_LENGTH_AND_ORDER",
  "FINE_TUNE_CLIPS",
  "TRANSITIONS",
]);

export const UserTutorialDto = z.object({
  tutorialId: TutorialId,
  firstOpenedAt: z.string(),
  lastOpenedAt: z.string(),
});

export const MarkTutorialOpenedDto = z.object({
  tutorialId: TutorialId,
});

export type TutorialId = z.infer<typeof TutorialId>;
export type UserTutorialDto = z.infer<typeof UserTutorialDto>;
export type MarkTutorialOpenedDto = z.infer<typeof MarkTutorialOpenedDto>;
